
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../Application/mixins/FormatMixin";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import DadosGerais from "./componentes/DadosGeraisTab.vue";
import Servicos from "./componentes/ServicosTab.vue";
import PagamentosTab from "./componentes/PagamentosTab.vue";
import ObservacoesTab from "./componentes/ObservacoesTab.vue";
import { store } from "../storeSimplificada";
import _ from "lodash";

export default {
  name: "app-os-form",
  directives: {
    mask,
  },
  data() {
    return {
      store,
      windowWidth: window.innerWidth,
    };
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
  ],
  components: {
    DadosGerais,
    Servicos,
    PagamentosTab,
    ObservacoesTab,
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    this.getDataInit();

    this.store.currentTab = 0;

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      if (this.$route.params.nfeData.nfeId) {
        this.setLoading(true);
      }
    },
    resetStore() {
      this.store.formGerais = {};
      this.store.formObjeto = {};
      this.store.formServicos = {};
      this.store.formPagamentos = {};
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },

    handleSair() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar o lançamento em andamento?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "comprasLista" });
          }
        });
    },
    async salvarOrdemSimplificada() {
      this.addLoadingToButton("submit_nova_os");
      const dataToSend = this.formatDataToSendToSimplificadaApi();
      try {
        if (Object.keys(this.$route.params).length !== 0) {
          const { id_os_simplificada } = this.$route.params.osData;
          dataToSend.id_os_simplificada = id_os_simplificada;
          await this.$http.post("/simplificada/update", dataToSend);
          this.$toast.success("Ordem de serviço atualizada com sucesso!");
          this.resetStore();
          this.$router.push({ name: "simplificada" });
        } else {
          await this.$http.post("/simplificada/create", dataToSend);
          this.$toast.success("Ordem de serviço salva com sucesso!");
          this.resetStore();
          this.$router.push({ name: "simplificada" });
        }
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("submit_nova_os");
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "nutsDigital",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
  },
  created() {
    this.store.dataFetching.servicos = true;
    this.store.isUpdate = false;
    if (Object.keys(this.$route.params).length !== 0) {
      this.store.isUpdate = true;
    }
  },
};
